/**
 * Filter out nullable values from an array in a Typescript supported way
 */
export function filterNonNull<TValue>(value: TValue | null): value is TValue {
  return value !== null;
}
